import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MdIosShare, MdSettings } from 'react-icons/md';
import { IoMdBarcode } from 'react-icons/io';
import { RiMessage2Line } from 'react-icons/ri';

import Button, { ButtonType } from 'legacy/common/components/button/Button';
import CenteredContainer from 'components/CenteredContainer';
import ScreenBottomBar from 'legacy/components/ScreenBottomBar';
import TextAllGuestsModal from 'legacy/events/components/guest-list/TextAllGuestsModal';
import ShareEvent from 'legacy/events/components/event-page/ShareEvent';
import { EventForHost } from 'legacy/events/types';
import ScanQRModal from 'legacy/events/components/scanQR/ScanQRModal';

import { useEventDashboard } from '../../context';
import ManageEvent from '../ManageEventModal';
import { useGetCanTextAll } from 'legacy/user/hooks';
import { useRouter } from 'next/router';

const EventHostBottomActionBar = () => {
  const { t } = useTranslation(['events']);
  const router = useRouter();
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);
  const [showScanQRModal, setShowScanQRModal] = useState(false);
  const [showTextAllGuests, setShowTextAllGuests] = useState<boolean>(false);
  const {
    goToEventView,
    toggleManageEventModal,
    data: { event, isManageEventModalOpen }
  } = useEventDashboard();
  const { data: textAllSettings } = useGetCanTextAll();

  const toggleCheckout = () => {
    router.push(`/events/${event._id}/checkout${location.search}`);
  };

  const toggleShareModal = () => {
    setIsShareModalOpen((shareModalOpen) => !shareModalOpen);
  };

  const toggleTextAllGuests = () => {
    setShowTextAllGuests((prevState) => !prevState);
  };

  const toggleScanQRModal = () => {
    setShowScanQRModal((showScanQRModal) => !showScanQRModal);
  };

  return (
    <>
      <ScreenBottomBar
        aboveContent={
          <CenteredContainer>
            <div className="flex justify-end pb-2">
              <Button rounded type={ButtonType.Primary} onClick={goToEventView}>
                <img src="/img/icons/calendar.svg" />
              </Button>
            </div>
          </CenteredContainer>
        }
      >
        <Button
          testId="button-share-event"
          type={ButtonType.Inverted}
          icon={<MdIosShare size={20} />}
          onClick={toggleShareModal}
          mobileRounded
        >
          <span className="hidden md:block">
            {t('events:dashboard.bottomBar.shareEvent')}
          </span>
        </Button>
        <Button
          testId="button-scan-ticket"
          type={ButtonType.Inverted}
          onClick={toggleScanQRModal}
          icon={<IoMdBarcode size={20} />}
          mobileRounded
        >
          <span className="hidden md:block">
            {t('events:dashboard.bottomBar.scanTickets')}
          </span>
        </Button>
        {textAllSettings?.canTextAll && (
          <>
            <TextAllGuestsModal
              eventId={event._id}
              tiers={(event as EventForHost).pricing?.tiers ?? []}
              totalGuests={event.totalGuests ?? 0}
              visible={showTextAllGuests}
              onClose={toggleTextAllGuests}
            />
            <Button
              type={ButtonType.Inverted}
              icon={<RiMessage2Line size={20} />}
              mobileRounded
              onClick={toggleTextAllGuests}
            >
              <span className="hidden md:block">
                {t('events:dashboard.bottomBar.textGuests')}
              </span>
            </Button>
          </>
        )}
        <Button
          type={ButtonType.Inverted}
          icon={<MdSettings size={20} />}
          onClick={toggleManageEventModal}
        >
          {t('events:dashboard.bottomBar.manageEvent')}
        </Button>
      </ScreenBottomBar>
      <ShareEvent
        eventId={event._id}
        isPrivate={event.private}
        isOrganizer={event.isOrganizer}
        shareToken={(event as EventForHost).shareToken}
        visible={isShareModalOpen}
        onClose={toggleShareModal}
      />
      {showScanQRModal && (
        <ScanQRModal eventId={event._id} onClose={toggleScanQRModal} />
      )}
      <ManageEvent
        event={event}
        onClickViewShareOptions={toggleShareModal}
        toggleManageEvent={toggleManageEventModal}
        visible={isManageEventModalOpen}
        toggleCheckout={toggleCheckout}
      />
    </>
  );
};

export default EventHostBottomActionBar;
